<template>
	<!-- Skip Link for Keyboard Navigation — teleported before v-main for first-focus order -->
	<Teleport to="#skip-links-portal">
		<a href="#main-content" class="skip-link" @click.prevent="() => { const el = document.getElementById('main-content'); if (el) el.focus(); }">Skip to main content</a>
	</Teleport>
	<div id="main-content" tabindex="-1" class="bg-color-granite pb-10" role="main" aria-label="About RISE Distributor page content">
		<div class="d-flex justify-center align-center w-100 position-relative">
			<v-img class="w-100 h-100"			
				:height="199"
				aspect-ratio="16/9"
				src="https://dellpartnerincentives.com/siteassets/Images/HomePartner/Banner/bgRISE2.jpg"
			></v-img>
			<div class="position-absolute page-header">
				<h1><LanguagePlaceholder default-text="About Rise" /></h1>
			</div>			
		</div>
        <div class="bg-color-granite w-100 h-100">
            <div class="bg-color-quartz w-100 h-100 my-2">
                <v-row no-gutters class="d-flex justify-center w-100 pa-0 pt-3 bg-color-teal-900 tx-color-white">
                <v-col cols="10" class="d-flex flex-column justify-start w-100 pa-0 py-8 tx-font-normal tx-font-size20">  
                    <v-row no-gutters>
                        <LanguagePlaceholder default-text='RISE is an incentive program that rewards partners for purchasing RISE eligible products with competitive core “$-per-box” rewards, multipliers, and bonuses - giving them the chance to earn up to $15,000 in rewards per incentive period.' />
                    </v-row>
                    <v-row no-gutters class="pt-10 tx-font-normal tx-font-size18">
                        <v-icon icon="mdi-play-circle-outline" size="x-large" class="pb-2 tx-font-normal"></v-icon>
                        <LanguagePlaceholder @custom-event="triggerCustomEvent"
                         is-html 
                         default-text="<custom-event action='showRISEVideo' class='dell-white' aria-label='Watch the RISE overview video on Vimeo'>WATCH</custom-event>: the RISE overview video.">
                        </LanguagePlaceholder>
                    </v-row>              
                </v-col>
                </v-row>
            </div>
            <div class="bg-color-granite w-auto h-100 my-2 mx-10" >
                <v-row no-gutters class="d-flex justify-center w-100 pa-0">
                <v-col cols="1" class="bg-color-quartz"></v-col>
                <v-col cols="10" class="d-flex justify-start w-100 pa-0 py-10 tx-font-bold bg-color-quartz">  
                    <h1>
                        <LanguagePlaceholder default-text='How Partners earn rewards with RISE'></LanguagePlaceholder>
                    </h1>   
                </v-col>
                <v-col cols="1" class="bg-color-quartz"></v-col>
                </v-row>
                <v-row no-gutters class="d-flex justify-center w-100 pa-0">
                <v-col cols="1" class="bg-color-quartz"></v-col>
                <v-col cols="10" class="bg-color-quartz d-flex justify-center w-100 pa-0 pb-10 tx-font-bold">  
                    <div class="bg-color-white tx-font-bolder w-100 h-100 mb-5">
                        <v-row>
                            <v-col cols="10" class="pa-10">
                                <strong>
                                <LanguagePlaceholder default-text='Core rewards'></LanguagePlaceholder>
                                </strong>
                                <p class="tx-font-bold pb-5">
                                <LanguagePlaceholder default-text='These rewards are earned and logged automatically the moment they purchase a RISE eligible product from you their Dell Technologies Authorized Distributor— all you need to do is report their sales, and we take care of the details!'></LanguagePlaceholder>
                                </p>
                                <strong>
                                <LanguagePlaceholder default-text='Multipliers'></LanguagePlaceholder>
                                </strong>
                                <p class="tx-font-bold pb-5">
                                <LanguagePlaceholder default-text='Core rewards can be multiplied by up to 1.6x when specific unit thresholds are reached.'></LanguagePlaceholder>
                                </p>
                                <strong>
                                <LanguagePlaceholder default-text='Bonuses'></LanguagePlaceholder>
                                </strong>
                                <p class="tx-font-bold pb-3">
                                <LanguagePlaceholder 
                                    is-html 
                                    default-text="Partners have additional earning opportunities with RISE bonuses. Visit the <route route-name='bonus-dashboard-distributor' style='text-decoration: underline;'>Bonus Dashboard</route> to see which bonuses your partners have qualified for.">
                                </LanguagePlaceholder>
                                </p>
                            </v-col>
                            <v-col cols="2" class="ma-0 pa-0">
                                <div class="w-100 h-100 my-2 pt-1" style="overflow: hidden;">
                                    <v-img cover class="h-100"
                                    :width="150"
                                    :height="180"
                                    src="https://dellpartnerincentives.com/siteassets/Images/AboutDisti/1.6x image.jpg"
                                    ></v-img>
                                </div>
                        </v-col>
                        </v-row>                        
                    </div>            
                </v-col>
                <v-col cols="1" class="bg-color-quartz"></v-col>
                </v-row>
                <v-row no-gutters class="d-flex justify-center w-100 pa-0">
                <v-col cols="1" class="bg-color-quartz"></v-col>
                <v-col cols="10" class="d-flex justify-start w-100 pa-0 py-10 tx-font-bold bg-color-quartz">  
                    <h1>
                        <LanguagePlaceholder default-text='How Partners can multiply their rewards'></LanguagePlaceholder>
                    </h1>   
                </v-col>
                <v-col cols="1" class="bg-color-quartz"></v-col>
                </v-row>
                <v-row no-gutters class="d-flex justify-center w-100 pa-0">
                <v-col cols="1" class="bg-color-quartz"></v-col>
                <v-col cols="10" class="d-flex justify-center w-100 pa-0 tx-font-bold">  
                    <div class="bg-color-white tx-font-bolder pa-10 pb-12">
                        <p class="tx-font-bold pb-10">
                        <LanguagePlaceholder default-text='When Partners achieve specific thresholds, their rewards will be multiplied by up to 1.6x. Thresholds are independently calculated for each product category. For example, they can achieve their PC+ threshold and receive up to 1.6x of their PC+ rewards without needing to meet the unit thresholds for Server+ or Storage+.'></LanguagePlaceholder>
                        </p>
                        <v-row>
                        <v-col cols="1" class="bg-color-steel d-flex justify-center align-center">
                            <v-img
                            :width="50"
                            src="https://dellpartnerincentives.com/siteassets/Images/AboutDisti/device-laptop-white-64px.png"
                            alt=""
                            ></v-img>
                        </v-col>
                        <v-col cols="4" style="border-left: 1px solid #C8C9C7;" class="d-flex justify-center align-start flex-column bg-color-grey tx-color-white">
                            <p class="tx-font-bolder tx-font-size18">
                                <LanguagePlaceholder default-text='PCS+'></LanguagePlaceholder>
                            </p>
                            <p class="tx-font-normal tx-font-size14">
                                <LanguagePlaceholder default-text="PCs units bought as SnS"></LanguagePlaceholder>
                            </p>
                        </v-col>
                        <v-col cols="7">
                            <v-row>
                            <v-col>
                                <v-row class="tx-color-quartz bg-color-steel justify-center py-1 tx-font-normal tx-font-size12 tx-font-bold">
                                <LanguagePlaceholder default-text='30 - 79 Units'></LanguagePlaceholder>
                                </v-row>
                                <v-row class="tx-color-teal-500 bg-color-quartz justify-center tx-font-size32">
                                <LanguagePlaceholder is-html default-text='1.2x'></LanguagePlaceholder>
                                </v-row> 
                                <v-row class="tx-color-teal-500 bg-color-quartz justify-center pb-1 tx-font-normal tx-font-size14 tx-font-bolder">
                                <LanguagePlaceholder is-html default-text='REWARDS'></LanguagePlaceholder>
                                </v-row>    
                            </v-col>
                            <v-col style="border-left: 1px solid #C8C9C7;">
                                <v-row class="tx-color-quartz bg-color-steel justify-center py-1 tx-font-normal tx-font-size12 tx-font-bold">
                                <LanguagePlaceholder default-text='80 - 159 Units'></LanguagePlaceholder>
                                </v-row>
                                <v-row class="tx-color-teal-600 bg-color-quartz justify-center tx-font-size32">
                                <LanguagePlaceholder is-html default-text='1.3x'></LanguagePlaceholder>
                                </v-row> 
                                <v-row class="tx-color-teal-600 bg-color-quartz justify-center pb-1 tx-font-normal tx-font-size14 tx-font-bolder">
                                <LanguagePlaceholder is-html default-text='REWARDS'></LanguagePlaceholder>
                                </v-row>    
                            </v-col>
                            <v-col style="border-left: 1px solid #C8C9C7;">
                                <v-row class="tx-color-quartz bg-color-steel justify-center py-1 tx-font-normal tx-font-size12 tx-font-bold">
                                <LanguagePlaceholder default-text='160 - 249 Units'></LanguagePlaceholder>
                                </v-row>
                                <v-row class="tx-color-teal-700 bg-color-quartz justify-center tx-font-size32">
                                <LanguagePlaceholder is-html default-text='1.4x'></LanguagePlaceholder>
                                </v-row> 
                                <v-row class="tx-color-teal-700 bg-color-quartz justify-center pb-1 tx-font-normal tx-font-size14 tx-font-bolder">
                                <LanguagePlaceholder is-html default-text='REWARDS'></LanguagePlaceholder>
                                </v-row>    
                            </v-col>
                            <v-col style="border-left: 1px solid #C8C9C7;">
                                <v-row class="tx-color-quartz bg-color-steel justify-center py-1 tx-font-normal tx-font-size12 tx-font-bold">
                                <LanguagePlaceholder default-text='250 - 399 Units'></LanguagePlaceholder>
                                </v-row>
                                <v-row class="tx-color-teal-800 bg-color-quartz justify-center tx-font-size32">
                                <LanguagePlaceholder is-html default-text='1.5x'></LanguagePlaceholder>
                                </v-row> 
                                <v-row class="tx-color-teal-800 bg-color-quartz justify-center pb-1 tx-font-normal tx-font-size14 tx-font-bolder">
                                <LanguagePlaceholder is-html default-text='REWARDS'></LanguagePlaceholder>
                                </v-row>    
                            </v-col>
                            <v-col style="border-left: 1px solid #C8C9C7;">
                                <v-row class="tx-color-quartz bg-color-steel justify-center py-1 tx-font-normal tx-font-size12 tx-font-bold">
                                <LanguagePlaceholder default-text='400+ Units'></LanguagePlaceholder>
                                </v-row>
                                <v-row class="tx-color-teal-900 bg-color-quartz justify-center tx-font-size32">
                                <LanguagePlaceholder is-html default-text='1.6x'></LanguagePlaceholder>
                                </v-row> 
                                <v-row class="tx-color-teal-900 bg-color-quartz justify-center pb-1 tx-font-normal tx-font-size14 tx-font-bolder">
                                <LanguagePlaceholder is-html default-text='REWARDS'></LanguagePlaceholder>
                                </v-row>    
                            </v-col>
                            </v-row>
                        </v-col>
                        </v-row>

                        <v-row class="ma-0 pa-0" style="height: 10px;">
                        <v-col cols="1" class="ml-16 mt-n2">
                            <v-img style="height: 20px;" class="ml-5"
                            :width="50"
                            src="https://dellpartnerincentives.com/siteassets/Images/AboutPartner/OR.png"
                            alt=""
                            ></v-img>
                        </v-col>
                        <v-col cols="4"></v-col>
                        <v-col cols="7"></v-col>
                        </v-row>

                        <v-row class="mt-2">
                        <v-col cols="1" class="bg-color-steel d-flex justify-center align-center">
                            <v-img
                            :width="50"
                            src="https://dellpartnerincentives.com/siteassets/Images/AboutDisti/device-server-tower-white-64px.png"
                            alt=""
                            ></v-img>
                        </v-col>
                        <v-col cols="4" style="border-left: 1px solid #C8C9C7;" class="d-flex justify-center align-start flex-column bg-color-teal-700 tx-color-white">
                            <strong>
                            </strong>
                            <p class="tx-font-normal">
                            </p>
                            <p class="tx-font-bolder tx-font-size18">
                                <LanguagePlaceholder default-text='SERVER+'></LanguagePlaceholder>
                            </p>
                            <p class="tx-font-normal tx-font-size14">
                                <LanguagePlaceholder default-text="Server units bought as SnS or B2B Smart Selection Offers"></LanguagePlaceholder>
                            </p>
                        </v-col>
                        <v-col cols="7">
                            <v-row>
                            <v-col>
                                <v-row class="tx-color-quartz bg-color-steel justify-center py-1 tx-font-normal tx-font-size12 tx-font-bold">
                                <LanguagePlaceholder default-text='5 - 8 Units'></LanguagePlaceholder>
                                </v-row>
                                <v-row class="tx-color-teal-500 bg-color-quartz justify-center tx-font-size32">
                                <LanguagePlaceholder is-html default-text='1.2x'></LanguagePlaceholder>
                                </v-row> 
                                <v-row class="tx-color-teal-500 bg-color-quartz justify-center pb-1 tx-font-normal tx-font-size14 tx-font-bolder">
                                <LanguagePlaceholder is-html default-text='REWARDS'></LanguagePlaceholder>
                                </v-row>    
                            </v-col>
                            <v-col style="border-left: 1px solid #C8C9C7;">
                                <v-row class="tx-color-quartz bg-color-steel justify-center py-1 tx-font-normal tx-font-size12 tx-font-bold">
                                <LanguagePlaceholder default-text='9 - 12 Units'></LanguagePlaceholder>
                                </v-row>
                                <v-row class="tx-color-teal-600 bg-color-quartz justify-center tx-font-size32">
                                <LanguagePlaceholder is-html default-text='1.3x'></LanguagePlaceholder>
                                </v-row> 
                                <v-row class="tx-color-teal-600 bg-color-quartz justify-center pb-1 tx-font-normal tx-font-size14 tx-font-bolder">
                                <LanguagePlaceholder is-html default-text='REWARDS'></LanguagePlaceholder>
                                </v-row>    
                            </v-col>
                            <v-col style="border-left: 1px solid #C8C9C7;">
                                <v-row class="tx-color-quartz bg-color-steel justify-center py-1 tx-font-normal tx-font-size12 tx-font-bold">
                                <LanguagePlaceholder default-text='13 - 16 Units'></LanguagePlaceholder>
                                </v-row>
                                <v-row class="tx-color-teal-700 bg-color-quartz justify-center tx-font-size32">
                                <LanguagePlaceholder is-html default-text='1.4x'></LanguagePlaceholder>
                                </v-row> 
                                <v-row class="tx-color-teal-700 bg-color-quartz justify-center pb-1 tx-font-normal tx-font-size14 tx-font-bolder">
                                <LanguagePlaceholder is-html default-text='REWARDS'></LanguagePlaceholder>
                                </v-row>    
                            </v-col>
                            <v-col style="border-left: 1px solid #C8C9C7;">
                                <v-row class="tx-color-quartz bg-color-steel justify-center py-1 tx-font-normal tx-font-size12 tx-font-bold">
                                <LanguagePlaceholder default-text='17 - 20 Units'></LanguagePlaceholder>
                                </v-row>
                                <v-row class="tx-color-teal-800 bg-color-quartz justify-center tx-font-size32">
                                <LanguagePlaceholder is-html default-text='1.5x'></LanguagePlaceholder>
                                </v-row> 
                                <v-row class="tx-color-teal-800 bg-color-quartz justify-center pb-1 tx-font-normal tx-font-size14 tx-font-bolder">
                                <LanguagePlaceholder is-html default-text='REWARDS'></LanguagePlaceholder>
                                </v-row>    
                            </v-col>
                            <v-col style="border-left: 1px solid #C8C9C7;">
                                <v-row class="tx-color-quartz bg-color-steel justify-center py-1 tx-font-normal tx-font-size12 tx-font-bold">
                                <LanguagePlaceholder default-text='21+ Units'></LanguagePlaceholder>
                                </v-row>
                                <v-row class="tx-color-teal-900 bg-color-quartz justify-center tx-font-size32">
                                <LanguagePlaceholder is-html default-text='1.6x'></LanguagePlaceholder>
                                </v-row> 
                                <v-row class="tx-color-teal-900 bg-color-quartz justify-center pb-1 tx-font-normal tx-font-size14 tx-font-bolder">
                                <LanguagePlaceholder is-html default-text='REWARDS'></LanguagePlaceholder>
                                </v-row>    
                            </v-col>
                            </v-row>
                        </v-col>
                        </v-row>

                        <v-row class="ma-0 pa-0" style="height: 10px;">
                        <v-col cols="1" class="ml-16 mt-n2">
                            <v-img style="height: 20px;" class="ml-5"
                            :width="50"
                            src="https://dellpartnerincentives.com/siteassets/Images/AboutPartner/OR.png"
                            alt=""
                            ></v-img>
                        </v-col>
                        <v-col cols="4"></v-col>
                        <v-col cols="7"></v-col>
                        </v-row>

                        <v-row class="mt-2">
                        <v-col cols="1" class="bg-color-steel d-flex justify-center align-center">
                            <v-img
                            :width="64"
                            src="https://dellpartnerincentives.com/siteassets/Images/AboutDisti/device-storage-array-white-64px.png"
                            alt=""
                            ></v-img>
                        </v-col>
                        <v-col cols="4" style="border-left: 1px solid #C8C9C7;" class="d-flex justify-center align-start flex-column bg-color-teal-900 tx-color-white">
                            <strong>
                            </strong>
                            <p class="tx-font-normal">
                            </p>
                            <p class="tx-font-bolder tx-font-size18">
                                <LanguagePlaceholder default-text='STORAGE+'></LanguagePlaceholder>
                            </p>
                            <p class="tx-font-normal tx-font-size14">
                                <LanguagePlaceholder default-text="Storage B2B Smart Selection Offers"></LanguagePlaceholder>
                            </p>
                        </v-col>
                        <v-col cols="7">
                            <v-row>
                            <v-col>
                                <v-row class="tx-color-quartz bg-color-steel justify-center py-1 tx-font-normal tx-font-size12 tx-font-bold">
                                <LanguagePlaceholder default-text='2 - 4 Units'></LanguagePlaceholder>
                                </v-row>
                                <v-row class="tx-color-teal-500 bg-color-quartz justify-center tx-font-size32">
                                <LanguagePlaceholder is-html default-text='1.2x'></LanguagePlaceholder>
                                </v-row> 
                                <v-row class="tx-color-teal-500 bg-color-quartz justify-center pb-1 tx-font-normal tx-font-size14 tx-font-bolder">
                                <LanguagePlaceholder is-html default-text='REWARDS'></LanguagePlaceholder>
                                </v-row>    
                            </v-col>
                            <v-col style="border-left: 1px solid #C8C9C7;">
                                <v-row class="tx-color-quartz bg-color-steel justify-center py-1 tx-font-normal tx-font-size12 tx-font-bold">
                                <LanguagePlaceholder default-text='5 - 7 Units'></LanguagePlaceholder>
                                </v-row>
                                <v-row class="tx-color-teal-600 bg-color-quartz justify-center tx-font-size32">
                                <LanguagePlaceholder is-html default-text='1.3x'></LanguagePlaceholder>
                                </v-row> 
                                <v-row class="tx-color-teal-600 bg-color-quartz justify-center pb-1 tx-font-normal tx-font-size14 tx-font-bolder">
                                <LanguagePlaceholder is-html default-text='REWARDS'></LanguagePlaceholder>
                                </v-row>    
                            </v-col>
                            <v-col style="border-left: 1px solid #C8C9C7;">
                                <v-row class="tx-color-quartz bg-color-steel justify-center py-1 tx-font-normal tx-font-size12 tx-font-bold">
                                <LanguagePlaceholder default-text='8 - 10 Units'></LanguagePlaceholder>
                                </v-row>
                                <v-row class="tx-color-teal-700 bg-color-quartz justify-center tx-font-size32">
                                <LanguagePlaceholder is-html default-text='1.4x'></LanguagePlaceholder>
                                </v-row> 
                                <v-row class="tx-color-teal-700 bg-color-quartz justify-center pb-1 tx-font-normal tx-font-size14 tx-font-bolder">
                                <LanguagePlaceholder is-html default-text='REWARDS'></LanguagePlaceholder>
                                </v-row>    
                            </v-col>
                            <v-col style="border-left: 1px solid #C8C9C7;">
                                <v-row class="tx-color-quartz bg-color-steel justify-center py-1 tx-font-normal tx-font-size12 tx-font-bold">
                                <LanguagePlaceholder default-text='11 - 12 Units'></LanguagePlaceholder>
                                </v-row>
                                <v-row class="tx-color-teal-800 bg-color-quartz justify-center tx-font-size32">
                                <LanguagePlaceholder is-html default-text='1.5x'></LanguagePlaceholder>
                                </v-row> 
                                <v-row class="tx-color-teal-800 bg-color-quartz justify-center pb-1 tx-font-normal tx-font-size14 tx-font-bolder">
                                <LanguagePlaceholder is-html default-text='REWARDS'></LanguagePlaceholder>
                                </v-row>    
                            </v-col>
                            <v-col style="border-left: 1px solid #C8C9C7;">
                                <v-row class="tx-color-quartz bg-color-steel justify-center py-1 tx-font-normal tx-font-size12 tx-font-bold">
                                <LanguagePlaceholder default-text='13+ Units'></LanguagePlaceholder>
                                </v-row>
                                <v-row class="tx-color-teal-900 bg-color-quartz justify-center tx-font-size32">
                                <LanguagePlaceholder is-html default-text='1.6x'></LanguagePlaceholder>
                                </v-row> 
                                <v-row class="tx-color-teal-900 bg-color-quartz justify-center pb-1 tx-font-normal tx-font-size14 tx-font-bolder">
                                <LanguagePlaceholder is-html default-text='REWARDS'></LanguagePlaceholder>
                                </v-row>    
                            </v-col>
                            </v-row>
                        </v-col>
                        </v-row>
                        <p class="tx-font-bold pt-10">
                        <LanguagePlaceholder default-text='Only PC hardware units (laptops, desktops and workstations) count towards the PCs+Displays+Peripherals reward multiplier thresholds (displays and peripherals do not). Once thresholds have been achieved, the rewards multiplier is applied to all products purchased within this category, including accessories.'></LanguagePlaceholder>
                        </p>
                    </div>            
                </v-col>
                <v-col cols="1" class="bg-color-quartz"></v-col>
                </v-row>
                <v-row no-gutters class="d-flex justify-center w-100 pa-0">
                <v-col cols="1" class="bg-color-quartz"></v-col>
                <v-col cols="10" class="d-flex justify-start w-100 pa-0 py-10 tx-font-bold bg-color-quartz">  
                    <h1>
                        <LanguagePlaceholder default-text='How Partner rewards are paid'></LanguagePlaceholder>
                    </h1>   
                </v-col>
                <v-col cols="1" class="bg-color-quartz"></v-col>
                </v-row>
                <v-row no-gutters class="d-flex justify-center w-100 pa-0">
                <v-col cols="1" class="bg-color-quartz"></v-col>
                <v-col cols="10" class="bg-color-quartz d-flex justify-center w-100 pa-0 pb-10 tx-font-bold">
                    <div class="bg-color-white tx-font-bolder w-100 h-100 mb-5">
                        <v-row>
                        <v-col cols="10" class="pl-8 pt-10 mb-0 pb-0">
                            <strong>
                            <LanguagePlaceholder default-text='At the end of each incentive period, rewards will be calculated and paid out in e-vouchers*.'></LanguagePlaceholder>
                            </strong>
                            <div class="d-flex my-5">
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<p>1.</p>&nbsp;&nbsp;&nbsp;
                            <p class="tx-font-bold pb-2">
                                <LanguagePlaceholder default-text='If Partners earn between $50 - $15,000, they will be able to exchange their RISE rewards for e-vouchers that they can spend with you, their Dell Technologies Authorized Distributor.'></LanguagePlaceholder>
                            </p>
                            </div>
                            <div class="d-flex justify-center align-center pa-5 ma-2 bg-color-teal-900 tx-color-white tx-font-normal w-25">
                            <LanguagePlaceholder is-html default-text='<a href="https://www.dellpartnerincentives.com/files/Acquisitions/Distributor%20Presentation/RISE%20Distributor%20Introductory%20Guide.pdf" class="dell-white">Click here</a> for more information.'></LanguagePlaceholder>
                            </div>    
                            <div class="d-flex justify-start align-center pa-3 ma-2 pl-0 tx-color-teal-900 tx-font-normal tx-font-bold">
                            <LanguagePlaceholder is-html default-text='* Please note, certain countries are paid via credit note only for local legislative reasons.'></LanguagePlaceholder>
                            </div>
                        </v-col>
                        <v-col cols="2" class="ma-0 pa-0">
                            <div class="w-100 h-100 my-2 pt-1" style="overflow: hidden;">
                                <v-img cover class="h-100"
                                :width="220"
                                :height="180"
                                src="https://dellpartnerincentives.com/siteassets/Images/AboutDisti/$15000(Teal).gif"
                                ></v-img>
                            </div>
                        </v-col>
                        </v-row>                
                    </div>            
                </v-col>
                <v-col cols="1" class="bg-color-quartz"></v-col>
                </v-row>
            </div>
            <div class="bg-color-teal-900 tx-color-white w-100 h-100 my-2">
                <v-row no-gutters class="d-flex justify-center w-100 pa-0">
                <v-col cols="10" class="d-flex justify-start w-100 pa-0 pt-10 tx-font-bold py-10">
                    <h1>
                        <LanguagePlaceholder default-text='A Step by Step Guide for Your Partners'></LanguagePlaceholder>
                    </h1>
                </v-col>
                </v-row>
                <v-row no-gutters class="d-flex justify-center w-100 pa-0 pt-3 pb-10 bg-color-teal-900 tx-color-white">
                    <v-col cols="10" class="d-flex flex-column justify-start w-100 pa-0 tx-font-bold">  
                        <v-card>
                            <v-tabs v-model="tab" grow color="#0B7C84">
                                <v-tab class="text-none bg-color-quartz tx-color-white" :value="1">
                                    <LanguagePlaceholder 
                                    default-text="1. Purchase" />
                                </v-tab>
                                <v-tab class="text-none bg-color-titanium tx-color-white" :value="2">
                                    <LanguagePlaceholder 
                                    default-text="2. Earn Rewards" />
                                </v-tab>
                                <v-tab class="text-none bg-color-quartz tx-color-white" :value="3">
                                    <LanguagePlaceholder 
                                    default-text="3. Grow Rewards" />
                                    </v-tab>
                                <v-tab class="text-none bg-color-titanium tx-color-white" :value="4">
                                    <LanguagePlaceholder 
                                    default-text="4. Spend Rewards" />
                                    </v-tab>
                            </v-tabs>
                            <v-tabs-window v-model="tab">
                                <v-tabs-window-item :value="1">
                                    <v-card flat>
                                        <v-card-text>
                                            <div class="tx-color-teal-900 tx-font-normal pa-5 pb-0 my-2">
                                                <strong class="tx-color-teal-900 tx-font-bold">
                                                    <LanguagePlaceholder default-text="Partners earn dollar rewards by purchasing RISE eligible products from a Dell Technologies Authorized Distributor."></LanguagePlaceholder>
                                                </strong>
                                            </div>
                                        </v-card-text>
                                        <div class="tx-color-white px-10 pb-5 pt-2">
                                            <v-btn class="text-none bg-color-teal-900" @click="systemStore.routerTo('home-eligible-products')">
                                                <LanguagePlaceholder default-text="View Eligible Products" />
                                            </v-btn>  
                                        </div>
                                    </v-card>
                                </v-tabs-window-item>

                                <v-tabs-window-item :value="2">
                                    <v-card flat>
                                        <v-card-text>
                                            <div class="tx-color-teal-900 tx-font-normal pa-5 pb-0 my-2">
                                                <strong class="tx-color-teal-900 tx-font-bold">
                                                    <p class="mb-2">
                                                        <LanguagePlaceholder default-text="Rewards accumulate throughout the 13-week incentive period, up to a total of $15,000."></LanguagePlaceholder>
                                                    </p>
                                                    <!-- <p class="mb-2"><v-icon icon="mdi-circle-small"></v-icon>
                                                        <LanguagePlaceholder default-text="There's no need to report your purchases. Simply order and your purchases are automatically logged."></LanguagePlaceholder>
                                                    </p>
                                                    <p class="mb-2"><v-icon icon="mdi-circle-small"></v-icon>
                                                        <LanguagePlaceholder default-text="Track how much you have earned using your 'My Performance' report."></LanguagePlaceholder>
                                                    </p> -->
                                                </strong>
                                            </div>
                                        </v-card-text>
                                        <!-- <div class="tx-color-white px-10 pb-5">
                                            <v-btn class="text-none bg-color-teal-900" @click="systemStore.routerTo('my-performance')">
                                                <LanguagePlaceholder default-text="My Performance" />
                                            </v-btn>  
                                        </div> -->
                                    </v-card>
                                </v-tabs-window-item>

                                <v-tabs-window-item :value="3">
                                    <v-card flat>
                                        <v-card-text>
                                            <div class="tx-color-teal-900 tx-font-normal pa-5 pb-0 my-2">
                                                <strong class="tx-color-teal-900 tx-font-bold">
                                                    <p class="mb-2">
                                                        <LanguagePlaceholder default-text="Rewards can be increased up to 1.6x using multipliers and boosted further with tailored bonuses."></LanguagePlaceholder>
                                                    </p>
                                                    <!-- <p class="mb-2"><v-icon icon="mdi-circle-small"></v-icon>
                                                        <LanguagePlaceholder default-text="You can also maximise your earnings with RISE bonuses—updated each incentive period."></LanguagePlaceholder>
                                                    </p> -->
                                                </strong>
                                            </div>
                                        </v-card-text>
                                        <!-- <div class="tx-color-white px-10 pb-5">
                                            <v-btn class="text-none bg-color-teal-900" @click="systemStore.routerTo('bonus-dashboard-partner')">
                                                <LanguagePlaceholder default-text="Bonus Dashboard" />
                                            </v-btn>  
                                        </div> -->
                                    </v-card>
                                </v-tabs-window-item>

                                <v-tabs-window-item :value="4">
                                    <v-card flat>
                                        <v-card-text>
                                            <div class="tx-color-teal-900 tx-font-normal pa-5 pb-0 my-2">
                                                <strong class="tx-color-teal-900 tx-font-bold">
                                                    <LanguagePlaceholder default-text='Rewards are redeemed as Authorized Distributor e-vouchers, based on the total value of a partner’s RISE earnings.'></LanguagePlaceholder>
                                                </strong>
                                                <!-- <br><br>
                                                <strong class="tx-color-teal-900 tx-font-bolder">
                                                    <LanguagePlaceholder default-text="If you earn $5000 or more in the incentive period, your rewards will be paid via credit note." />
                                                </strong>
                                                <br>
                                                <LanguagePlaceholder default-text="At the end of the incentive period, your rewards will be calculated and credit notes will be issued to the Dell Technologies Authorized Distributors you have purchased from throughout the previous incentive period. They will be sent the credit note(s) to apply to your future orders." />
                                                <br><br>
                                                <strong class="tx-color-teal-900 tx-font-bolder">
                                                    <LanguagePlaceholder default-text="If you earn less than $5000 in the incentive period, your rewards will earn e-vouchers." />
                                                </strong>
                                                <br>
                                                <LanguagePlaceholder default-text="You will be able to exchange your RISE rewards for distributor e-vouchers. You can decide which Dell Technologies Authorized Distributors you would like to receive e-vouchers for." /> -->
                                            </div>
                                        </v-card-text>
                                        <!-- <div class="tx-color-white px-10 pb-5 pt-2">
                                            <v-btn class="text-none bg-color-teal-900" @click="systemStore.routerTo('redemption')">
                                                <LanguagePlaceholder default-text="Redeem My Rewards" />
                                            </v-btn>  
                                        </div> -->
                                    </v-card>
                                </v-tabs-window-item>
                            </v-tabs-window>
                        </v-card>
                    </v-col>
                </v-row>
            </div>     
        </div>

        <v-dialog persistent v-model="showVideo" width="650" role="dialog" aria-labelledby="video-dialog-title">
            <v-card width="650">
                <v-card-title id="video-dialog-title">Welcome To Rise Video</v-card-title>
                <v-card-text>

                    <v-row style="padding:60% 0 0 0;position:relative;">
                        <iframe width="600" height="338" controls preload="none" 
                        :src="vimeoEmbedSrc"
                        frameborder="0" 
                        allow="autoplay; fullscreen; picture-in-picture; clipboard-write" 
                        style="position:absolute;top:0;left:0;width:100%;height:100%;" 
                        title="Welcome To RISE - Introduction video for the RISE Partner Incentive Program"
                        aria-label="Welcome To RISE video player"></iframe>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="showVideo = false" aria-label="Close video dialog">
                        <LanguagePlaceholder default-text="Close" />
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>
</template>

<script setup>
import { ref, computed, onBeforeMount } from 'vue'
import { useSystemStore } from '@/stores/system'
import LanguagePlaceholder from '@/components/LanguagePlaceholder.vue'

const systemStore = useSystemStore()
const showVideo = ref(false);

const VIMEO_PLAYER_QUERY =
    'title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479'

// Map ISO language codes (lowercase) to Vimeo video IDs.
// Fallback behavior: if a language isn't mapped, use English.
const vimeoVideoIdByLanguage = Object.freeze({
    en: '1174417709',
    // fr: 'PUT_FRENCH_VIDEO_ID_HERE',
    de: '1174423704',
    es: '1174423791',
    it: '1174423876',
    pl: '1174423961',
    tr: '1174424049',
})

const vimeoEmbedSrc = computed(() => {
    const lang = (systemStore.selectedLanguage || '').toString().toLowerCase()
    const videoId = vimeoVideoIdByLanguage[lang] || vimeoVideoIdByLanguage.en
    return `https://player.vimeo.com/video/${videoId}?${VIMEO_PLAYER_QUERY}`
})

const triggerCustomEvent = (action) => {
    if (action == 'showRISEVideo') {
        showVideo.value = true
    }
}

const tab = ref(null)

</script>

<style scoped>
    /* Issue #20: Focus indicator for tab elements */
    :deep(.v-tab:focus-visible) {
        outline: 3px solid #005B63 !important;
        outline-offset: -3px !important;
        box-shadow: inset 0 0 0 3px #005B63 !important;
        z-index: 1 !important;
    }

    /* Issue #21: Active tab text contrast - #0B7C84 on #D2D2D2 only 3.2:1, override to dark teal */
    :deep(.v-tab.v-tab--selected) {
        color: #003540 !important;
    }
</style>